import React from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";

function Vision() {
  return (
    <>
      <Header />

      {/* Title Section with background */}
      <section
        className="content-section title-top"
        style={{ backgroundImage: `url(${topback})` }}
      >
        <div className="pattern-overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 title-heading">
                <h2>Vission & Mission</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container mt-5">
        <div className="row">
          {/* Basic Information */}

          {/* Vision */}
          <div className="col-md-12 mt-4">
            <div className="committee-card">
              <div className="card-header">
                <h3 className="m-0">Institutional Vision</h3>
              </div>
              &nbsp;
              <div className="card-body">
                <p>
                  Vision of SDWG Govt. College Beetan is to provide
                  multi-dimensional education to its students. It fulfills this
                  objective not only through classroom instructions that are
                  imparted in different courses of study, but also supplements
                  the human dimension in a holistic manner by inculcating
                  amongst the students the traditional and cultural values. The
                  Institution strives to provide the young minds with a vision
                  of a resplendent future and chisels their persona so as to
                  prepare them as ideal citizens in service of society and the
                  Nation.
                </p>
                <p>
                  The academic session is regulated as per the directions of the
                  chair and the higher authorities. Different committees are
                  formulated for smooth conduct of administrative and academic
                  processes. The IQAC plays a pivotal role in planning these
                  assignments and ensures their execution. Staff meetings are
                  held almost every month, delegating assignments and
                  responsibilities to teachers as well as student
                  representatives for proper implementation of various
                  activities.
                </p>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-12 mt-4">
            <div className="committee-card">
              <div className="card-header">
                <h3 className="m-0">
                  Institutional Mission: “FROM DARKNESS TO LIGHT”
                </h3>
              </div>
              &nbsp;
              <div className="card-body">
                <p>
                  The college is committed to the overall personality
                  development of the students through innovative
                  teaching-learning methods by adopting a diversified
                  curriculum, making the students ready to contribute in
                  nation-building and welfare of society when they leave the
                  portals of the college.
                </p>
                <h5>Broad Objectives of the College:</h5>
                <ol>
                  <li>
                    Provide students with market-relevant, need-specific, and
                    latest academic programs to enhance their professional
                    competence.
                  </li>
                  <li>
                    Create a conducive academic environment for students to
                    develop skills for pursuing knowledge and become capable
                    global citizens.
                  </li>
                  <li>
                    Provide best educational resources and infrastructure to
                    convert them into confident and employable youth.
                  </li>
                  <li>
                    Involve students in activities that foster personal growth
                    by inculcating ethical and human values.
                  </li>
                  <li>Create a value-based knowledge society.</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      &nbsp;
      &nbsp;
      <Footer />
    </>
  );
}

export default Vision;
